import { render, staticRenderFns } from "./templateSetting.vue?vue&type=template&id=314994f9&scoped=true&"
import script from "./templateSetting.vue?vue&type=script&lang=js&"
export * from "./templateSetting.vue?vue&type=script&lang=js&"
import style0 from "./templateSetting.vue?vue&type=style&index=0&id=314994f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314994f9",
  null
  
)

export default component.exports